// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Leetcode Wizard
 * Leetcode Wizard API Description
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface LoginTransferTokenRequestDto
 */
export interface LoginTransferTokenRequestDto {
    /**
     *
     * @type {string}
     * @memberof LoginTransferTokenRequestDto
     */
    token: string;
}

/**
 * Check if a given object implements the LoginTransferTokenRequestDto interface.
 */
export function instanceOfLoginTransferTokenRequestDto(
    value: object,
): value is LoginTransferTokenRequestDto {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function LoginTransferTokenRequestDtoFromJSON(json: any): LoginTransferTokenRequestDto {
    return LoginTransferTokenRequestDtoFromJSONTyped(json, false);
}

export function LoginTransferTokenRequestDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): LoginTransferTokenRequestDto {
    if (json == null) {
        return json;
    }
    return {
        token: json['token'],
    };
}

export function LoginTransferTokenRequestDtoToJSON(
    value?: LoginTransferTokenRequestDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        token: value['token'],
    };
}
